import { render, staticRenderFns } from "./Scheme.vue?vue&type=template&id=bd61b338"
import script from "./Scheme.vue?vue&type=script&lang=ts"
export * from "./Scheme.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports